"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

var _log = _interopRequireDefault(require("../log.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var submission = new _GatewayService["default"]('submission-receiver');

// We make this check because STUDENT roles can't call
// the POST endpoint. And TEACHER roles can't access their own
// work through the post endpoint, so we direct them to the GET.
// When GRIND-924 lands, this can probably be removed and
// all users can use the post for everything.
var isCallingUser = function isCallingUser(userKey) {
  var currentUserKey = _lodash["default"].get(window, 'kc.tokenParsed.ampId');

  return userKey === currentUserKey;
};

var fetchSubmissions = function fetchSubmissions() {
  var userKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var cardstackKey = arguments.length > 1 ? arguments[1] : undefined;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var appName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'curriculum';
  var params = {
    appName: appName,
    appGroup1Id: cardstackKey,
    limit: limit
  };

  if (isCallingUser(userKeys)) {
    return submission.get("api/0.1/submission", {
      params: params
    });
  } else {
    if (_lodash["default"].isString(userKeys)) {
      userKeys = [userKeys];
    }

    ;
    return submission.post("api/0.2/submission/find/".concat(appName), userKeys, {
      params: params
    });
  }
};

var fetchSubmissionForActivity = function fetchSubmissionForActivity() {
  var userKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var activityKey = arguments.length > 1 ? arguments[1] : undefined;
  var appName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'curriculum';

  if (!_lodash["default"].isString(activityKey) || _lodash["default"].isEmpty(activityKey)) {
    _log["default"].warn('Trying to get submission for invalid activityKey:', activityKey);

    return;
  }

  ;
  var params = {
    appName: appName,
    appId: activityKey
  };

  if (isCallingUser(userKeys)) {
    return submission.get("api/0.1/submission", {
      params: params
    });
  } else {
    if (_lodash["default"].isString(userKeys)) {
      userKeys = [userKeys];
    }

    ;
    return submission.post("api/0.2/submission/find/".concat(appName), userKeys, {
      params: params
    });
  }
};

var fetchRecentSubmissions = function fetchRecentSubmissions(userKeys, limit, maxAge) {
  var appName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'curriculum';
  var params = {
    maxAge: maxAge,
    limit: limit
  };

  if (_lodash["default"].isString(userKeys)) {
    userKeys = [userKeys];
  }

  ;
  return submission.post("api/0.2/submission/recent/".concat(appName), userKeys, {
    params: params
  });
};

var fetchSubmissionBreadcrumbs = function fetchSubmissionBreadcrumbs(userKeys, maxAge, unitKeys) {
  var includeExtendedData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var cardstackKeys = arguments.length > 4 ? arguments[4] : undefined;
  var payload = {
    maxNumDays: maxAge,
    userBusinessKeys: userKeys,
    includeExtendedData: includeExtendedData
  };

  if (unitKeys) {
    payload.unitBusinessKeys = unitKeys;
  }

  if (cardstackKeys) {
    payload.cardstackBusinessKeys = cardstackKeys;
  }

  return submission.post("api/0.1/metadata/breadcrumb", payload);
};

var postSubmissions = function postSubmissions(envelopePayload) {
  return submission.post("api/0.1/submission/envelope", envelopePayload);
};

var forceSubmissions = function forceSubmissions(userKey, submissionsPayload) {
  return submission.post("api/0.1/submission/user/".concat(userKey), submissionsPayload);
};

var deleteSubmissions = function deleteSubmissions() {
  var cardstackKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var params = {
    appGroup1Id: "appGroup1Id=".concat(cardstackKeys.join('&appGroup1Id='))
  };
  return submission["delete"]("api/0.2/submission?".concat(params.appGroup1Id));
};

var _default = {
  fetchSubmissions: fetchSubmissions,
  fetchSubmissionForActivity: fetchSubmissionForActivity,
  fetchRecentSubmissions: fetchRecentSubmissions,
  fetchSubmissionBreadcrumbs: fetchSubmissionBreadcrumbs,
  postSubmissions: postSubmissions,
  forceSubmissions: forceSubmissions,
  deleteSubmissions: deleteSubmissions
};
exports["default"] = _default;